<span>
  <div>
    <a routerLink=".">
      <img style="margin-right: 15px" src="../../../assets/langs/es.svg" />
    </a>
    <a [routerLink]="[lang.EN]"> <img style="margin-right: 15px" src="../../../assets/langs/en.svg" /></a>
    <a [routerLink]="[lang.PT]"> <img src="../../../assets/langs/pt-pt.svg" /></a>
  </div>
</span>
